import recaptchaMixin from '../../common/recaptcha/recaptcha-mixin'
import Multiselect from 'vue-multiselect'
import {getSettlements, getHouseNumbers, getStreets, getSearchResults} from '../../common/api/online-inquiry.api.js'

export default {
	name: 'ONI01-online-inquiry',
	mixins: [
		recaptchaMixin,
	],
	components: {
		multiselect: Multiselect,
	},
	data() {
		return {
			phoneNumber: '',
			name: null,
			settlement: null,
			street: null,
			houseNumber: null,
			recaptcha: '',

			searchResults: [],
			coveredSettlements: [],
			coveredStreets: [],
			coveredStreetsList: [],
			coveredHouseNumbers: [],

			foundStreet: {},
			foundStreetId: '',

			isSearchLoading: false,
			areSettlementsLoading: false,
			areStreetsLoading: false,
			areHouseNumbersLoading: false,

			requiredFieldsMissing: false,
			noResultsFound: false,

			recaptchaToken: '',

			errorWhileFetchingSearchResults: false,
			errorWhileFetchingCoveredSettlements: false,
			errorWhileFetchingSettlements: false,
			errorWhileFetchingStreets: false,
			errorWhileFetchingHouseNumbers: false,
		}
	},
	methods: {
		onRecaptchaVerify(response) {
			this.recaptchaToken = response

			if (this.recaptchaToken) {
				this.sendForm()
			} else {
				console.error('Recaptcha validation failed')
			}
		},
		resetRecaptcha() {
			this.$refs.recaptchaRef.reset()
			this.recaptchaToken = ''
		},
		onSubmit(){
			if (navigator.onLine) {
				this.resetRecaptcha();
				this.$refs.recaptchaRef.execute()
			} else {
				console.error('Recaptcha error')
			}
		},
		sendForm() {
			this.noResultsFound = false
			this.requiredFieldsMissing = false
			this.searchResults = []
			this.errorWhileFetchingSearchResults = false

			const areRequiredFieldsFilled =
				(this.name && this.settlement) ||
				(this.settlement && this.street && this.houseNumber) ||
				this.phoneNumber

			if (areRequiredFieldsFilled) {
				this.isSearchLoading = true

				const searchParams = {
					telepules: this.settlement,
					utca: this.street,
					telefonszam: this.phoneNumber,
					nev: this.name,
					hazszam: this.houseNumber,
					recaptcha: this.recaptchaToken,
				}
				getSearchResults(searchParams)
					.then(response => {
						if (!response.data.length) {
							this.noResultsFound = true
						} else {
							this.searchResults = response.data
						}

						this.isSearchLoading = false
					})
					.catch(error => {
						this.isSearchLoading = false
						this.errorWhileFetchingSearchResults = true
						console.error(error)
					})
			} else {
				this.requiredFieldsMissing = true
			}
		},
		filterSettlements(option, search) {
			return option.toLowerCase().includes(search.toLowerCase());
		},
		filterStreets(option, search) {
			return option.toLowerCase().includes(search.toLowerCase());
		},
		resetFields(fields) {
			fields.forEach(field => {
				if (Array.isArray(this[field])) {
					this[field] = [];
				} else {
					this[field] = null;
				}
			});
		},
		
	},
	watch: {
		settlement(selectedSettlement) {
			if (selectedSettlement != null) {
				this.resetFields(['street', 'houseNumber', 'coveredStreetsList', 'coveredHouseNumbers']);

				this.areStreetsLoading = true
				this.errorWhileFetchingStreets = false
				getStreets(selectedSettlement)
					.then(response => {
						this.coveredStreets = response.data
						this.coveredStreetsList = this.coveredStreets.map(street => street.megnevezes)
						this.areStreetsLoading = false
					})
					.catch(error => {
						this.areStreetsLoading = false
						this.errorWhileFetchingStreets = true
						console.error(error)
					})
			}
		},
		street(selectedStreet) {
			if (selectedStreet != null) {
				this.resetFields(['houseNumber', 'coveredHouseNumbers']);

				this.errorWhileFetchingHouseNumbers = false
				this.foundStreet = this.coveredStreets.find(street => street.megnevezes === selectedStreet)
				this.foundStreetId = this.foundStreet.id
				this.areHouseNumbersLoading = true
				getHouseNumbers(this.foundStreetId)
					.then(response => {
						this.coveredHouseNumbers = response.data
						this.areHouseNumbersLoading = false
					})
					.catch(error => {
						this.areHouseNumbersLoading = false
						this.errorWhileFetchingHouseNumbers = true
						console.error(error)
					})
			}
		},
	},
	mounted() {
		this.areSettlementsLoading = true
		getSettlements()
			.then(response => {
				this.coveredSettlements = response.data
				this.areSettlementsLoading = false
			})
			.catch(error => {
				this.areSettlementsLoading = false
				this.errorWhileFetchingCoveredSettlements = true
				console.error(error)
			})
	},
}



// WEBPACK FOOTER //
// ../source/modules/ONI01-online-inquiry/ONI01-online-inquiry.js